import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

/**
 * The Ask Attorney Share mark: three four-point sparkles, from the design.
 * `small` drops the lowest sparkle so it stays legible at 16px. `twoTone`
 * draws the small sparkles in mint, like the logo's navy and mint; use it
 * at 22px and up, where the small ones still read.
 */
const SparkleIcon = ({
  small,
  twoTone,
  sx,
  ...props
}: SvgIconProps & { small?: boolean; twoTone?: boolean }) => (
  <SvgIcon
    {...props}
    sx={[
      twoTone && {
        '& .sparkle-accent': { fill: t => t.palette.secondary.main },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <path d="M9 4c.6 4.6 2.4 6.4 7 7-4.6.6-6.4 2.4-7 7-.6-4.6-2.4-6.4-7-7 4.6-.6 6.4-2.4 7-7z" />
    <path
      className="sparkle-accent"
      d="M18 2c.3 1.7.9 2.4 3 3-2.1.6-2.7 1.3-3 3-.3-1.7-.9-2.4-3-3 2.1-.6 2.7-1.3 3-3z"
    />
    {!small && (
      <path
        className="sparkle-accent"
        d="M18 16.5c.25 1.4.8 2 2.5 2.5-1.7.5-2.25 1.1-2.5 2.5-.25-1.4-.8-2-2.5-2.5 1.7-.5 2.25-1.1 2.5-2.5z"
      />
    )}
  </SvgIcon>
)

export default SparkleIcon
